import { call, put, select } from "redux-saga/effects";
import { selectIncomingCalls, setIncomingCalls } from "../../../state/userAgent/userAgentSlice";
import { hideCallNotification } from "../../../browser/notifications";

export function* removeIncomingCallSaga(action) {
    const callId = action.payload;
    try {
        const incomingCalls = yield select(selectIncomingCalls);
        const updatedIncomingCalls = incomingCalls.filter(call => call.id !== callId);
        yield put(setIncomingCalls(updatedIncomingCalls));

        // Hide call notification
        hideCallNotification(callId);

        console.log("Incoming call removed successfully");
    } catch (error) {
        console.error("Error removing incoming call:", error);

    }


}